module.exports = __webpack_public_path__ + "static/media/pertix-logo.ca53ce38.svg";